/**
 * 车辆信息详情，用来审核车辆
 */

import React, { Component } from 'react';
import { Modal, Button, Divider, Row, Col, Form, Input, Table, Tooltip, Descriptions, Tabs } from 'antd';

import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';

//引入样式
import './vehicleAuditStyle.css';

import messager from '../../ui/messager';
import http from '../../../axios/http';

//加载中遮罩
import Loading from '../../ui/Loading';

//权限码
import { global_data } from '../../ui/auth'


const vehicleField = [{
    "text": "创建人",
    "field": "nickname",
}, {
    "text": "状态",
    "field": "procurementStatusStr",
}, {
    "text": "VIN",
    "field": "vin",
}, {
    "text": "车牌号",
    "field": "plateNo",
}, {
    "text": "初登日期",
    "field": "registerDate",
}, {
    "text": "品牌型号",
    "field": "brandModel",
}, {
    "text": "使用性质",
    "field": "usePropertyStr",
}, {
    "text": "车主姓名",
    "field": "owner",
}, {
    "text": "车主住所",
    "field": "ownerAddress",
}];

const otherField = [{
    "text": "车辆名称",
    "field": "vehicleName",
}, {
    "text": "配置(加装)",
    "field": "detailHighlight",
}, {
    "text": "能源类型",
    "field": "fueltypeStr",
}, {
    "text": "变速箱类型",
    "field": "gearTypeStr",
}, {
    "text": "发动机号",
    "field": "engineNo",
}, {
    "text": "驱动方式",
    "field": "driveModeStr",
}, {
    "text": "表显里程(公里)",
    "field": "mileage",
}, {
    "text": "初次登记地",
    "field": "registerLocation",
}, {
    "text": "过户次数",
    "field": "transferTimes",
}, {
    "text": "钥匙数量",
    "field": "keyNum",
}, {
    "text": "证件",
    "field": "certificateStr",
}, {
    "text": "是否质保",
    "field": "warrantyStr",
}, {
    "text": "车身颜色",
    "field": "colorStr",
}, {
    "text": "内饰颜色",
    "field": "innerColorStr",
}, {
    "text": "客户心理价（万元）",
    "field": "intentPrice",
}, {
    "text": "评估报价（万元）",
    "field": "valuatePrice",
}, {
    "text": "预计整备费用（元）",
    "field": "cleanPrice",
}, {
    "text": "所属门店",
    "field": "shopName",
}, {
    "text": "卖车意向",
    "field": "saleIntentStr",
}, {
    "text": "车主来源",
    "field": "clientOrginStr",
}, {
    "text": "联系人",
    "field": "contact",
}, {
    "text": "联系电话",
    "field": "contactTel",
}, {
    "text": "交强险有效期",
    "field": "mandatoryInsuranceDate",
}, {
    "text": "商业险有效期",
    "field": "commerciaInsuranceDate",
}, {
    "text": "出厂日期",
    "field": "productionDate",
}, {
    "text": "年检有效期",
    "field": "examinationDate",
}, {
    "text": "是否按揭",
    "field": "mortgageStr",
}
, {
    "text": "是否置换",
    "field": "replacementStr",
}, {
    "text": "置换推荐人",
    "field": "replaceRecommend",
}, {
    "text": "推荐人所属门店",
    "field": "recommendShopName",
},
{
    "text": "推荐人所属部门",
    "field": "assessmentDepartment",
    "colSpan": 1
},
{
    "text": "其他部门",
    "field": "otherDepartment",
    "colSpan": 2
}
, {
    "text": "回收配件",
    "field": "recycle",
    "colSpan": 3
}, {
    "text": "特殊情况说明",
    "field": "specialMark",
    "colSpan": 3
}, {
    "text": "备注",
    "field": "mark",
    "colSpan": 3
}];

const assessmentColum = [
    {
        "text": "评估基准日",
        "field": "assessBaseDate",
    },
    {
        "text": "中准评估价（万元）",
        "field": "assessValue0",
    },
    {
        "text": "评估人",
        "field": "assessor",
    },
    {
        "text": "评估描述",
        "field": "assessDesc",
        "colSpan": 3
    }

]

//车辆照片信息
const vehicleImages = [{
    text: '左前',
    field: 'leftFrontImage'
}];

//车辆手续照片信息
const certificationField = [{
    text: '行驶证',
    field: 'licenseImg'
},
{
    text: '登记证第一,二页',
    field: 'registration12Img'
},
{
    text: '含签注信息的最后两页照片',
    field: 'registrationLastImg'
},
{
    text: '身份证正面',
    field: 'creditFront'
},
{
    text: '身份证背面',
    field: 'creditBack'
},
{
    text: '营业执照',
    field: 'businessLicense'
},
{
    text: '合同1',
    field: 'contract_1'
},
{
    text: '合同2',
    field: 'contract_2'
},
{
    text: '合同3',
    field: 'contract_3'
},
{
    text: '采购审批表',
    field: 'purchaseAudit'
},
{
    text: '微信审批截图',
    field: 'wechatAudit'
},
{
    text: '授权委托书',
    field: 'authProxy'
},
{
    text: '付款指示函',
    field: 'payLetter'
},
];

class ProcurementVehicleDetail extends Component {

    state = {
        activeKey: 'base',
        image: null,
        previewVisible: false,
        previewImage: null,
        loadingVisible: false,
        assessVisible: false, //显示评估车辆信息输入框
        assessRejectVisible: false, //显示退回输入框
        visible: false, //编辑框显示
    }

    columns = [
        {
            title: '操作时间',
            dataIndex: 'time',
            width: '20%',
        }, {
            title: '操作人',
            dataIndex: 'name',
            width: '10%',
        }, {
            title: '状态',
            dataIndex: 'status',
            width: '10%',
            render: (text, record, index) => {
                let status = { "DRAFT": "草稿", "EVALUATING": "评估中", "REJECT": "退回", "EVALUATED": "已评估", "FAIL": "战败", "DEAL": "成交", "INVALID": "作废", "NONEED": "无需评估" };
                return status[text];
            }
        }, {
            title: '说明',
            dataIndex: 'info',
            width: '20%',
            render: (text, record, index) => (
                <Tooltip title={text}>
                    <span>{text}</span>
                </Tooltip>
            )
        }];

    followLogcolumns = [
        {
            title: '跟进时间',
            dataIndex: 'insertTime',
            width: '20%',
        }, {
            title: '跟进人',
            dataIndex: 'creatorName',
            width: '10%',
        }, {
            title: '下次跟进时间',
            dataIndex: 'nextTime',
            width: '20%',

        }, {
            title: '跟进记录',
            dataIndex: 'remark',
            width: '40%',
            render: (text, record, index) => (
                <Tooltip title={text}>
                    <span>{text}</span>
                </Tooltip>
            )
        }
    ];

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        for (let i = 0; i < field.length; i += 1) {
            let path = editData != null && editData[field[i]["field"] + "Thumb"] ? "data:image/jpeg;base64," + editData[field[i]["field"] + "Thumb"] : "";
            let imgurl = editData && editData[field[i]["field"]] ? editData[field[i]["field"]] : "";
            let img = this.createImageCol(path, imgurl, field[i].text, i);
            dom.push(img);
        }
        return dom;
    }

    createImageList = (imageKey) => {
        let dom = [];
        const { editData } = this.props;
        let vehicleImages = editData[imageKey];
        let thumbnails = editData[imageKey + "Thumb"];
        if (vehicleImages == null || vehicleImages.length === 0) return;
        if (thumbnails != null && thumbnails.length > 0) {
            thumbnails.forEach((item, index) => {
                if (item && item.length > 0) {
                    let image = "data:image/jpeg;base64," + item
                    let img = this.createImageCol(image, vehicleImages[index], null, index);
                    dom.push(img);
                }
            })
        }
        return dom;
    }
    createAssessmentDom=(vehicleAssessment)=>{
        let dom=[];
            assessmentColum.map((item, index) => {
                let val = vehicleAssessment[item.field];
                if (!val) {
                    val = "";
                }
                let cell=(
                    <Descriptions.Item key={index} label={item.text} span={item.colSpan}>{val}</Descriptions.Item>
                ) 
                dom.push(cell)
                return index.id
            })
        return dom
    }
    createHistoryDom=(assessmentHistoryL)=>{
        let dom=[];
        for (let index = 0; index < assessmentHistoryL.length; index++) {
            let ah=assessmentHistoryL[index]
            assessmentColum.map((item, index) => {
                let val = ah[item.field];
                if (!val) {
                    val = "";
                }
                let cell=(
                    <Descriptions.Item key={index} label={item.text} span={item.colSpan}>{val}</Descriptions.Item>
                ) 
                dom.push(cell)
                return index.id
            })
        }
        return dom
    }


    createCertificationImg = () => {
        let dom = [];
        const { editData } = this.props;
        let certificationImages = editData["certificationImgs"];
        let thumbnails = editData["certificationImgsThumb"];
        if (thumbnails) {
            certificationField.forEach((item, index) => {
                if (thumbnails[item.field] && thumbnails[item.field] !== "") {
                    console.log(certificationImages[item.field]);
                    let image = "data:image/jpeg;base64," + thumbnails[item.field];
                    let img = this.createImageCol(image, certificationImages[item.field], item.text, index);
                    dom.push(img);
                }
            });
        }
        return dom;
    }

    createImageCol = (image, url, text, key) => {
        let img = (
            <Col span={3} key={key} style={{ margin: '5px 0' }}>
                <Image
                    onlyView={true}
                    file={image}
                    text={text}
                    url={url}
                />
            </Col>
        );
        return img;
    }

    createVehicleDesc = (items) => {
        let editData = this.props.editData;
        return <Descriptions title="" bordered column={3}>
            {items.map((item, index) => {
                let val = editData[item.field];
                if (!val) {
                    val = "";
                }
                return <Descriptions.Item key={index} label={item.text} span={item.colSpan}>{val}</Descriptions.Item>
            })}
        </Descriptions>;
    }

    createImageTextCol = (image, url, text, key) => {
        let img = (
            <Col span={3} key={key} style={{ margin: '5px 0' }}>
                <Image
                    onlyView={true}
                    file={image}
                    text={text}
                    url={url}
                />
                <div className="image-desc">{text}</div>
            </Col>
        );
        return img;
    }

    //评估车辆
    assessVehicle = () => {
        this.setState({ assessVisible: true })
    }

    //评估车辆
    assessRejectVehicle = () => {
        this.setState({ assessRejectVisible: true })
    }

    hiddenAssessModal = () => {
        this.setState({ assessVisible: false });
    }

    hiddenAssessRejectModal = () => {
        this.setState({ assessRejectVisible: false });
    }

    doAssessSuccess = () => {
        const { successCallback, queryData, onCancel } = this.props;
        onCancel();
        this.hiddenAssessModal();
        this.hiddenAssessRejectModal();
        queryData.notChangePage = true;
        successCallback(queryData);
    }

    render() {
        const { visible, onCancel, editData } = this.props;
        let { operationRecords, vehicleFollowLogs, vehicleAssessment, assessmentHistory } = editData;
        return (
            <Modal
                width={1200}
                visible={visible}
                title="采购车辆详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                zIndex={1000}
                footer={[
                    editData["procurementStatus"] === "EVALUATING" && global_data.authCode.includes("PROCUREMENT_VEHICLE_MANAGE") ?
                     <Button key="assess" type="primary" onClick={this.assessVehicle.bind(this)}>评估</Button> 
                     : "",
                    editData["procurementStatus"] === "EVALUATING" && global_data.authCode.includes("PROCUREMENT_VEHICLE_MANAGE")?
                     <Button key="reject" type="primary" onClick={this.assessRejectVehicle.bind(this)}>退回</Button> 
                     : "",
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
                <div>
                    <Tabs tabPosition='left' activeKey={this.state.activeKey}
                        onChange={(activeKey) => {
                            this.setState({ activeKey: activeKey });
                        }}
                    >
                        <Tabs.TabPane tab="基本信息" key="base">
                            <Divider orientation="left">基本信息</Divider>
                            {this.createVehicleDesc(vehicleField)}
                            <Divider orientation="left">其他信息</Divider>
                            {this.createVehicleDesc(otherField)}
                            <Divider orientation="left">手续照片</Divider>
                            <Row>{this.createCertificationImg()}</Row>
                            <Divider orientation="left">车辆照片</Divider>
                            <Row>
                                {this.createImageDom(vehicleImages)}
                                {this.createImageList("vehicleImages", "vehicleImagesThumb")}
                            </Row>
                            <Divider orientation="left">其他照片</Divider>
                            <Row>{this.createImageList("otherImages", "otherImagesThumb")}</Row>
                            <Divider orientation="left">车辆操作记录</Divider>
                            <Row>
                                <Table rowKey="time" columns={this.columns} dataSource={operationRecords} pagination={{ pageSize: 5 }} />
                            </Row>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="跟进记录" key="followLog">
                            <Row>
                                <Table rowKey="insertTime" columns={this.followLogcolumns} dataSource={vehicleFollowLogs} pagination={{ pageSize: 5 }} />
                            </Row>
                        </Tabs.TabPane>
                        {vehicleAssessment ? 
                        <Tabs.TabPane tab="评估信息" key="assessment">
                            <Descriptions title="" bordered column={3}>
                                {this.createAssessmentDom(vehicleAssessment)}
                            </Descriptions>
                        </Tabs.TabPane> : ""}
                        {assessmentHistory ? 
                        <Tabs.TabPane tab="评估历史" key="history">
                            <Descriptions title="" bordered column={3}>
                                {this.createHistoryDom(assessmentHistory)}
                            </Descriptions>
                        </Tabs.TabPane> : ""}
                    </Tabs>
                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据处理中..."
                />
                <Assessment
                    visible={this.state.assessVisible}
                    onCancel={this.hiddenAssessModal}
                    vehicleId={editData.id}
                    successCallback={this.doAssessSuccess}
                />
                <AssessReject
                    visible={this.state.assessRejectVisible}
                    onCancel={this.hiddenAssessRejectModal}
                    vehicleId={editData.id}
                    successCallback={this.doAssessSuccess}
                />
            </Modal>
        );
    }
}


class AssessmentForm extends Component {


    assessVehicle = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["vehicleId"] = this.props.vehicleId;
            http.post({
                url: "/procurement/web/vehicle/assessment/add",
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    this.props.successCallback();
                    messager.notify("评估成功！");
                }
            });
        });
    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="评估车辆"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.assessVehicle}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    <Form.Item label="价格(万元)：">
                        {getFieldDecorator('assessValue', {
                            rules: [
                                { required: true, message: '评估价格不能为空!' },]
                        })(
                            <Input style={{ width: '100%' }} />
                        )}
                    </Form.Item>
                    <Form.Item label="评估描述：">
                        {getFieldDecorator('assessDesc', {
                            rules: [
                                { required: true, message: '评估信息不能为空!' },
                                { max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea style={{ width: '100%' }} />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

class AssessRejectForm extends Component {


    rejectVehicle = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = this.props.vehicleId;
            http.post({
                url: "/procurement/web/vehicle/reject",
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    this.props.successCallback();
                    messager.notify("退回成功！");
                }
            });
        });
    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="退回车辆"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.rejectVehicle}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    <Form.Item label="退回原因：">
                        {getFieldDecorator('reason', {
                            rules: [
                                { required: true, message: '退回原因不能为空!' },]
                        })(
                            <Input.TextArea style={{ width: '100%' }} />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const Assessment = Form.create()(AssessmentForm);

const AssessReject = Form.create()(AssessRejectForm);

export default ProcurementVehicleDetail;